<template>
	<form class="forgot-password-form" @submit.prevent="submit">
		<div class="fieldset">
			<FieldInput
				name="email"
				type="email"
				label="Enter your email"
				v-model="fields.email"
				:errors="errors.email"
			/>
		</div>
		<div class="fieldset">
			<SubmitButton v-bind="submitButton" label="Send reset link" />
		</div>
	</form>
</template>

<script>
import FieldInput from '@/components/shared/FieldInput'
import SubmitButton from '@/components/shared/SubmitButton'
import form from '@/mixins/form'

export default {
	name: 'ForgotPasswordForm',
	mixins: [form.forgotPassword],
	components: {
		FieldInput,
		SubmitButton
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/components';

.forgot-password-form {
	width: 100%;
	max-width: 20rem;
	.fieldset {
		margin-bottom: 2rem;
	}
	input[type='submit'] {
		@include button;
	}
}
</style>
